import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'whatsappFormat',
    pure: true,
    standalone: false
})
export class WhatsAppFormatPipe implements PipeTransform {
  /**
   * Formatea el texto del mensaje con estilos de WhatsApp y Markdown
   * Convierte: **texto** y *texto* -> <strong>texto</strong>, _texto_ -> <em>texto</em>, etc.
   */
  transform(text: string): string {
    if (!text) return '';
    
    return text
      // Negritas doble: **texto** -> <strong>texto</strong>
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      // Negritas simple: *texto* -> <strong>texto</strong>
      .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
      // Cursiva: _texto_ -> <em>texto</em>
      .replace(/_(.*?)_/g, '<em>$1</em>')
      // Tachado: ~texto~ -> <del>texto</del>
      .replace(/~(.*?)~/g, '<del>$1</del>')
      // Código: ```texto``` -> <code>texto</code>
      .replace(/```(.*?)```/g, '<code>$1</code>')
      // Saltos de línea: \n -> <br>
      .replace(/\\n/g, '<br>')
      // Saltos de línea reales -> <br>
      .replace(/\n/g, '<br>');
  }
}
